import './index.scss'

import React, { useEffect, useState } from 'react'
import BEMHelper from 'react-bem-helper'
import { Link, useLocation } from 'react-router-dom'
import Container from '../../components/Container'
import Ident from '../../components/Ident'
import Dropdown from '../../components/Dropdown'
import Icon from '../../components/Icon'

import { path as BrandbookPath } from '../../pages/brandbook'
import { path as BrandbookBrandStrategyPath } from '../../pages/brandbook/brand-strategy'

import logo from '../../assets/images/brandbook/logo.svg'
import typography from '../../assets/images/brandbook/typography.svg'
import colors from '../../assets/images/brandbook/colors.svg'
import grid from '../../assets/images/brandbook/grid.svg'
import icons from '../../assets/images/brandbook/icons.svg'
import imagery from '../../assets/images/brandbook/imagery.jpg'
import toneOfVoice from '../../assets/images/brandbook/tone-of-voice.svg'
import product from '../../assets/images/brandbook/product.png'


const bem = new BEMHelper('header')

export default function Header() {
  const [expanded, setExpanded] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setExpanded(false)
  }, [location])

  const toggle = () => setExpanded((value) => !value)

  return (
    <header {...bem('', { expanded })}>
      <Container size="large" node="nav" {...bem('content', ['desktop'])}>
      <div {...bem('ident')}>
      <Link to={BrandbookPath}>
        <Ident>
          <svg viewBox="0 0 80 80">

            <rect x="1" width="78" height="78" id="background" />

            <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />

          </svg>

        </Ident>
      </Link>
    </div>

        <div {...bem('menu')}>
          <div {...bem('links')}>
          <Link to={BrandbookPath} {...bem('link')}>
            Intro
          </Link>
            <Link to={BrandbookBrandStrategyPath} {...bem('link')}>
              Brand Strategy
            </Link>
            <div {...bem('link')}>
            <Dropdown trigger="Tools and Rules" left large noClose>
               <div {...bem('link-buttons')}>
                <Link to="/brandbook/logo" {...bem('link-button')}>
                    <img src={logo} alt="" /> Logotype
                </Link>

                <Link to="/brandbook/colors" {...bem('link-button')}>
                    <img src={colors} alt="" /> Colors
                </Link>
                <Link to="/brandbook/typography" {...bem('link-button')}>
                    <img src={typography} alt="" /> Typography
                </Link>


                <Link to="/brandbook/icons" {...bem('link-button')}>
                    <img src={icons} alt="" /> Icons
                </Link>
                <Link to="/brandbook/grid" {...bem('link-button')}>
                    <img src={grid} alt="" /> Grid/Layout
                </Link>

                <Link to="/brandbook/imagery" {...bem('link-button')}>
                    <img src={imagery} alt="" /> Imagery
                </Link>

                <Link to="/brandbook/product" {...bem('link-button')}>
                    <img src={product} alt="" /> Product
                </Link>


                <Link to="/brandbook/tone-of-voice" {...bem('link-button')}>
                    <img src={toneOfVoice} alt="" /> Tone of voice
                </Link>


                </div>
              </Dropdown>

            </div>

          </div>
          <div {...bem('trigger')}>
            <button type="button" onClick={toggle} className="header__burger">
              <Icon icon="menu" />
            </button>
          </div>
        </div>
      </Container>

      <Container node="nav" {...bem('content', ['mobile'])}>

        <button type="button" onClick={toggle} className="header__close">
          <Icon icon="close" />
        </button>

        <Link to={BrandbookPath} {...bem('link')}>
          Intro
        </Link>

        <Link to={BrandbookBrandStrategyPath} {...bem('link')}>
          Brand Strategy
        </Link>

        <Link to="/brandbook/logo" {...bem('link')}>
             Logotype
        </Link>

                <Link to="/brandbook/colors" {...bem('link')}>
                     Colors
                </Link>

        <Link to="/brandbook/typography" {...bem('link')}>
             Typography
        </Link>


          <Link to="/brandbook/icons" {...bem('link')}>
               Icons
          </Link>

        <Link to="/brandbook/grid" {...bem('link')}>
             Grid/Layout
        </Link>

        <Link to="/brandbook/imagery" {...bem('link')}>
             Imagery
        </Link>

        <Link to="/brandbook/product" {...bem('link')}>
             Product
        </Link>

        <Link to="/brandbook/tone-of-voice" {...bem('link')}>
             Tone of voice
        </Link>

      </Container>
    </header>
  )
}
